import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import Button from '@components/@core/AnimatedButton';
import Icon from '@components/@core/Icon';

const LandingContact = ({ title = 'Amplify your team! Invest a few minutes to get started.', subtitle = 'Or contact us if you have questions', btntitle = 'DEMO NOW', onDemoNow = () => {} }) => (
    <div className="landing-contact d-h-center flex-wrap">
        <div className="container">
            <Row>
                <Col>
                    <h3 className="title">{title}</h3>
                    <p className="sub-title mb-5">{subtitle}</p>
                    <Button className="btn-demo m-auto ai-center d-flex" onClick={() => onDemoNow()} name={btntitle} />
                    <div className="phone text-center mt-5">
                        <Icon name="fas fa-phone-volume me-2" color="white" size={16} />
                        <a href="tel:866.943.8371" className="clickable-phone-number">
                            866.943.8371
                        </a>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
);

LandingContact.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    btntitle: PropTypes.string,
    onDemoNow: PropTypes.func,
};

export default memo(LandingContact);
